// extracted by mini-css-extract-plugin
module.exports =  {"root":"U2HUA218bFmcWiIFjlbc","bannersnackEditor":"uZOlE0IRFMBMVyAmptTN"};